import { ValidationService } from 'aspnet-client-validation';

export class CustomValidationService {
    private validationService: ValidationService;

    constructor() {
        this.validationService = new ValidationService();
    }

    public initialize(): void {
        this.validationService.bootstrap();
        this.setupCustomProviders();
    }

    private setupCustomProviders(): void {
        this.setupMinimumAgeProvider();
        this.setupRequiredIfProvider();
    }

    private setupMinimumAgeProvider(): void {
        this.validationService.addProvider('minimumage', (value, _element, params) => {
            let date = new Date(value);
            let today = new Date();

            let minimumAge = parseInt(params['age']) ?? 18;
            let age = today.getFullYear() - date.getFullYear();
            let monthDiff = today.getMonth() - date.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
                age--;
            }

            return age >= minimumAge;
        });
    }

    private setupRequiredIfProvider(): void {
        this.validationService.addProvider('requiredif', (value, element, params) => {
            var targetId = params.otherproperty;
            var targetValue = params.otherpropertyvalue;

            var otherPropertyValue = (targetValue == null || targetValue == undefined ? "" : targetValue).toString();

            var otherPropertyElement = document.querySelector('#' + targetId) as HTMLInputElement;

            if (otherPropertyElement && otherPropertyElement.checked.toString() === otherPropertyValue.toLowerCase()) {
                if (value !== '') {
                    return this.validationService.validateField(element);
                }
                return false;
            }

            return true;
        });
    }
}
